// ===================================================================
// KAIXO - FollowersList
// ===================================================================
// Vista 'followers' extraída de ChannelsV2Modal. Lista usuarios que
// siguen cualquiera de los canales del owner. Al tocar a uno dispara
// el evento global open_chat_with_user para iniciar chat 1-a-1.
// ===================================================================

import React from 'react';
import ct from './i18n';

export default function FollowersList({ followers, loading }) {
    if (loading) {
        return (
            <div className="v2-body">
                <p className="v2-center">{ct.loading}</p>
            </div>
        );
    }

    if (!followers || followers.length === 0) {
        return (
            <div className="v2-body">
                <p className="v2-center v2-dim">
                    {ct.emptyFollowers || 'Aún no tienes seguidores.'}
                </p>
            </div>
        );
    }

    const handleOpenChat = (f) => {
        try {
            window.dispatchEvent(new CustomEvent('open_chat_with_user', {
                detail: {
                    userId: String(f._id),
                    name: f.name,
                    avatar: f.avatar,
                    language: f.language
                }
            }));
        } catch { /* no-op */ }
    };

    return (
        <div className="v2-body">
            {followers.map(f => (
                <div
                    key={f._id}
                    className="v2-channel-item"
                    onClick={() => handleOpenChat(f)}
                >
                    <div className="v2-channel-avatar">
                        {f.avatar
                            ? <img src={f.avatar} alt="" loading="lazy" decoding="async" />
                            : (f.name?.[0] || '?').toUpperCase()}
                    </div>
                    <div className="v2-channel-info">
                        <div className="v2-channel-name">
                            {f.name}
                            {f.country && (
                                <span className="v2-badge" style={{ marginLeft: 6, fontSize: 11 }}>
                                    {f.country}
                                </span>
                            )}
                        </div>
                        <div className="v2-channel-preview">
                            {f.channelsFollowedCount > 1
                                ? `${ct.followsNChannels || 'Sigue'} ${f.channelsFollowedCount} ${ct.ofYourChannels || 'de tus canales'}`
                                : (ct.followsYou || 'Te sigue')}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}
